import { render, staticRenderFns } from "./OverdueTasks.vue?vue&type=template&id=3069706e"
import script from "./OverdueTasks.vue?vue&type=script&lang=js"
export * from "./OverdueTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports